import { MessageItemType } from '../../components/WechatyMessage/interface'
import request from '../request'

export function getGroupWelcome() {
    return request.get<MessageItemType[]>('/group/welcome')
}

export function addGroupWelcome(data: MessageItemType[]) {
    return request.post('/group/welcome', data)
}

export function deleteGroupWelcome(idList: string[]) {
    return request.post('/group/welcome/delete', idList)
}
